import { ModalPositionType } from '../types';

export const ModalPositionProp: {
  [key in ModalPositionType]: string;
} = {
  top: 'modal-top',
  bottom: 'modal-bottom',
  middle: 'modal-middle',
};
